import _ from "underscore";

const proR4NarrativeIds = [
	"2d7d59c8cdda3d2bda471aca44863d78", // Russia is powerful
	"d81b318ef64aba89353d802dac87d03b", // Russia is a victim
	"07ffa8cc2364642064242a6fdd012dbe", // Russia protects Russkiy Mir
	"0cbbb6360267cbf4ddfdeb6701236d10", // Baltics/Moldova plagued by poor governance
	"2fe98880d219b34ec658cc13e39f8fea", // West is corrupt, imperialistic and discriminatory
	"a72458bcbf931b2719393869b1176c43", // Baltic/Moldovan democracy is a sham
	"7e0000e78734198de2c43e029ad0e942", // The West is in decline
	"b882f61c87f8b5a5375f51a7b9de5838", // Russophobia and fascism present in Baltics/Moldova
	"7e4bc4ab4458e7b66419c8eb78f76c36", // NATO alliance is fragile
	"b5a22c0ca1fd162707afaaf41acec38c", // NATO is a hostile relic
];

const antiR4NarrativeIds = [
	"9b3cb8663cdccc46eb71b2fb61576cf2", // Russia is corrupt and unprincipled
	"289796dce16e28e1709def63e824be38", // Russia is an aggressor and a threat
	"01d6cc9a080ee04b6a470c3c17899faa", // Baltics/Moldova have good governance
	"a6c3037a42df3f8786ec9e42552aa01f", // Western values are a model
	"b6b52fefeb089f386ce6a1dc57e0a0e1", // Western ties are advantageous
	"2f64b59537094a643296233b15dda61d", // Baltics/Moldovans should be proud of sovereignty and identity
	"d483216742b1e6afb9aed78b74428f1d", // NATO alliance is strong
];

// tags: array of strings (narrative ids)
// flatNarratives: array of narrative objects
export const formatGECTags = (params) => {
	const { tags, flatNarratives } = params;

	const proR4narratives = [];
	const antiR4narratives = [];
	const returnArray = [];

	_.each(tags, (narId) => {
		const proId = _.find(proR4NarrativeIds, (id) => {
			return id === narId;
		});

		if (proId) {
			const proTag = _.find(flatNarratives, (nar) => {
				return proId === nar.id;
			});
			if (proTag) {
				proR4narratives.push(proTag);
			}
		} else {
			const antiId = _.find(antiR4NarrativeIds, (id) => {
				return id === narId;
			});
			if (antiId) {
				const antiTag = _.find(flatNarratives, (nar) => {
					return antiId === nar.id;
				});
				antiR4narratives.push(antiTag);
			}
		}
	});

	if (proR4narratives.length > 0) {
		returnArray.push({
			header: "Pro R4 Narratives",
			color: {
				id: "red",
				dark: "#d82555", // coral
				light: "#e01d07", // bright red
				colorblind: "colorblindTiny",
			},
			bullets: _.pluck(proR4narratives, "name"),
			id: "proR4",
		});
	}

	if (antiR4narratives.length > 0) {
		returnArray.push({
			header: "Anti R4 Narratives",
			color: {
				id: "Cornflower",
				dark: "#345ac6", // Light Blue
				light: "#345ac6", // Blue
				colorblind: "colorblindBroken",
			},
			bullets: _.pluck(antiR4narratives, "name"),
			id: "antiR4",
		});
	}

	return returnArray;
};

export const fakeFunction = () => {};
